import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getColor } from '../../../utils';

type HandProps = DefaultIconProps & {
  color?: 'white' | 'brown' | 'salmon';
};

export const HandIllustration = ({
  color = 'salmon',
  width = 45,
  marginLeft,
  marginRight,
  containerSize,
}: HandProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 34">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFBF00"
          d="M32.847 3.963c0 2.19-1.775 3.963-3.965 3.963-2.188 0-3.964-1.774-3.964-3.963S26.694 0 28.882 0c2.19 0 3.965 1.774 3.965 3.963"
        />
        <path
          fill="#000"
          d="M28.883 7.926V0c2.189 0 3.964 1.774 3.964 3.963 0 2.19-1.776 3.963-3.965 3.963"
          opacity=".1"
        />
        <path
          fill="#FFBF00"
          d="M26.051 13.741c0 2.189-1.775 3.963-3.965 3.963-2.188 0-3.964-1.774-3.964-3.963s1.776-3.963 3.964-3.963c2.19 0 3.965 1.774 3.965 3.963"
        />
        <path
          fill="#000"
          d="M22.087 17.704V9.777c2.189 0 3.965 1.774 3.965 3.964s-1.776 3.963-3.965 3.963"
          opacity=".1"
        />
        <path
          fill={getColor(color)}
          d="M24.138 17.945c1.734 0 3.398.817 4.363 2.258.61.907.208 1.287-.159 1.67l-5.514-.25-3.734-.113c-.956 0-1.687-.432-2.483 1.335l-.038.088c.032-.053.402-.558 3.268-.675l3.024.063 3.04.14c1.883-.025 7.652-.015 8.332-.377l5.956-3.64c2.99-1.572 3.703-1.287 4.563-.088.403.56.294 1.341-.237 1.781L34.085 28.26c-.529.507-1.19.873-1.915.975l-.014.003c-.288.064-.584.1-.889.1l-8.402 1.275-.548.085c-1.356.206-2.726.31-4.097.31l-9.78-.395-4.012-10.828s6.627-5.547 12.684-3.242c1.46.553 2.787 1.402 4.348 1.402h2.678z"
        />
        <path
          fill="#00396C"
          d="M1.212 18.835c.89-.33 1.818-.036 2.074.655l4.64 12.528c.255.691-.258 1.518-1.147 1.846-.888.33-1.817.036-2.074-.655L.067 20.682c-.257-.69.256-1.518 1.145-1.847"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
